import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const GEOIP_COUNTRY_SCHEMA = Object.freeze({
  NAME: '',
  ISO_CODE: '',
});
const RECORD = generateSchema(GEOIP_COUNTRY_SCHEMA);
const KEYS: any = generateKeys(GEOIP_COUNTRY_SCHEMA);

export class GeoipCountry extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get isoCode(): string {
    return this.get(KEYS.ISO_CODE);
  }
}
